import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaEdit } from "react-icons/fa";


export default function useColumnsHabitacion(togglePop, guardarSelectedCama) {

	const [t] = useTranslation("global");

	const onEditarCama = (cama) => {
		guardarSelectedCama(cama);
		togglePop();
	}

	const convertirFecha = (fecha) => {
		if (fecha != null && fecha != '') {
			var dateFormat = new Date(parseInt(fecha, 10));
			return dateFormat.toLocaleDateString();
		} else {
			return '';
		}
	}


	const columns = useMemo(
		() => [
			{
				Header: t("app.cama.table.habitacion"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-negro-columna">{row.original.numeroHabitacion}</p>
					</div>
				)
			},
			{
				Header: t("app.cama.table.identificador"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.identificador}</p>
					</div>
				)
			},
			{
				Header: t("app.cama.table.tamano"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.tamanyo}</p>
					</div>
				)
			},
			{
				Header: t("app.cama.table.tipoCama"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.tipoCama.nombre}</p>
					</div>
				)
			},
			{
				Header: t("app.cama.table.idMotor"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.idMotor}</p>
					</div>
				)
			},
			{
				Header: t("app.cama.table.fechaInstalacion"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{convertirFecha(row.fechaInstalacion)}</p>
					</div>
				)
			},
			{
				accessor: 'action',
				Cell: ({ row }) => (
					<div className={'container-actionsTabla'}>
						<button className={'button-actionRecord'} onClick={(e) => onEditarCama(row.original, e)}><FaEdit size='20' className={'icon-button-editarRecord'}/></button>
					</div>
				),
			}
		],
		[t]
	);

	return columns;
}